import React from 'react';
import SectionEditorDropdown from './SectionEditorDropdown';

const LAYOUT_OPTIONS = [
  { label: 'Full Width', value: 'full_width' },
  { label: 'Two Column', value: 'two_column' },
] as const;

export type LayoutValue = typeof LAYOUT_OPTIONS[number]['value'];

interface LayoutDropdownProps {
  className?: string;
  initialValue: LayoutValue;
  name?: string;
  onChange: (value: string) => any;
}

// AIDEV-NOTE: the layout lives in the body HTML itself (see useLayout's wrapHtml/unwrapHtml), so
// `name` submits a field no controller permits. It exists to keep the select out of the owner's
// param namespace — pass the owner's name so Rails doesn't log it as an unpermitted param.
const LayoutDropdown = ({
  className = '',
  initialValue,
  name = 'section[column_layout]',
  onChange,
}: LayoutDropdownProps) => {
  const defaultValue = LAYOUT_OPTIONS.find(opt => opt.value === initialValue);

  return (
    <SectionEditorDropdown
      className={className}
      initialValue={defaultValue.value}
      label="Layout"
      name={name}
      options={[...LAYOUT_OPTIONS]}
      onChange={onChange}
    />
  );
};

export default LayoutDropdown;
